import request from '@/api/request'

export default {
  async getColors () {
    return (await request.get(`module/action/marketplace/privalia/color`)).data
  },
  async getSizes () {
    return (await request.get(`module/action/marketplace/privalia/size`)).data
  },
  async getCategories () {
    return (await request.get(`module/action/marketplace/privalia/category/retrieve`)).data
  },
  async getBrands () {
    return (await request.get(`module/action/marketplace/privalia/brand/retrieve`)).data
  }
}



// WEBPACK FOOTER //
// ./src/api/marketplace/privalia/index.js